import { render, staticRenderFns } from "./app.resource.vue?vue&type=template&id=7dad1c7d&scoped=true&"
import script from "./app.resource.vue?vue&type=script&lang=js&"
export * from "./app.resource.vue?vue&type=script&lang=js&"
import style0 from "./app.resource.vue?vue&type=style&index=0&id=7dad1c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dad1c7d",
  null
  
)

export default component.exports